import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HourglassHalf from './icon-hourglass-half.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HourglassHalf {...validProps} />;
}
SvgComponent.iconName = 'hourglassHalf';

/**
 * @deprecated This is a legacy icon
 */
export const HourglassHalfIcon = svgIconWrapper(SvgComponent);
